import {Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnInit, Output,} from '@angular/core';
import {DragMode} from '@blocks/table/drag-mode';

@Component({
  selector: 'app-table-interaction',
  templateUrl: './table-interaction.component.html',
  styleUrls: ['./table-interaction.component.scss']
})
export class TableInteractionComponent implements OnInit {
  constructor(private elementRef: ElementRef) {
  }

  @HostBinding('class.mode-row')
  get modeRow() {
    return this.mode === 'row';
  }

  @HostBinding('class.mode-col')
  get modeCol() {
    return this.mode === 'col';
  }

  @Input() mode: DragMode;

  @Output() mousedownEvent = new EventEmitter<MouseEvent>();
  @Output() interactionElementClicked = new EventEmitter<MouseEvent>();
  @Output() dragHandleClicked = new EventEmitter<MouseEvent>();

  ngOnInit(): void {
  }

  offset(): number {
    return this.mode === 'col' ? this.elementRef.nativeElement.offsetWidth : this.elementRef.nativeElement.offsetHeight;
  }

  @HostListener('mousedown', ['$event'])
  mousedownHandler(event: MouseEvent) {
    this.mousedownEvent.emit(event);
  }

  @HostListener('click', ['$event'])
  click(event: MouseEvent) {
    if (event.button !== 0) {
      return;
    }

    event.stopPropagation();

    if (this.mode === 'col') {
      const xMiddle = (event.target as HTMLElement).offsetWidth / 2;
      if (event.offsetX > xMiddle - 5 && event.offsetX < xMiddle + 5) {
        this.dragHandleClicked.emit(event);
      } else {
        this.interactionElementClicked.emit(event);
      }
    } else {
      const yMiddle = (event.target as HTMLElement).offsetHeight / 2;
      if (event.offsetY > yMiddle - 5 && event.offsetY < yMiddle + 5) {
        this.dragHandleClicked.emit(event);
      } else {
        this.interactionElementClicked.emit(event);
      }
    }
  }
}
